<template>
  <v-row dense>
    <v-col cols="6" class="mb-1">
      <h4 class="text-caption font-weight-semibold mb-1">
        Number of bets
      </h4>
      <v-currency-field
        v-model="form.amount"
        :options="{
          allowNegative: false,
          precision: 0,
          valueAsInteger: false,
          valueRange: {
            min: 0,
            max: 1000,
          }
        }"
        class="rounded-0 grey100--text"
        solo hide-details flat dense

        @change="onChange"
      >
        <template #append>
          <fai
            :class="{invisible: form.amount > 0}"
            :icon="['fas', 'infinity']"
          />
        </template>
      </v-currency-field>
    </v-col>

    <v-col cols="12" class="mb-1">
      <h4 class="text-caption font-weight-semibold mb-1">
        On win
      </h4>
      <v-currency-field
        v-model="form.onWinValue"
        :disabled="form.onWinAction === 'reset'"
        :options="{
          precision: 0,
          valueAsInteger: false,
          valueRange: {
            min: -10000,
            max: 10000,
          }
        }"
        class="rounded-0 autobet-action-input grey100--text"
        solo hide-details flat dense

        @change="onChange"
      >
        <template #prepend-inner>
          <v-btn-toggle
            v-model="form.onWinAction"
            class="mr-2"
            mandatory dense tile borderless

            @change="onChange"
          >
            <v-btn
              value="reset"
              :ripple="false" small text
              class="text-caption text-none mr-1"
              @click="form.onWinValue = 0; onChange()"
            >
              Reset
            </v-btn>
            <v-btn
              value="increase"
              :ripple="false" small text
              class="text-caption text-none"
            >
              Increase by:
            </v-btn>
          </v-btn-toggle>
        </template>
        <template #append>
          <fai
            class="text-body-"
            :icon="['fad', 'percentage']"
          />
        </template>
      </v-currency-field>
    </v-col>

    <v-col cols="12" class="mb-1">
      <h4 class="text-caption font-weight-semibold mb-1">
        On loss
      </h4>
      <v-currency-field
        v-model="form.onLossValue"
        :disabled="form.onLossAction === 'reset'"
        :options="{
          precision: 0,
          valueAsInteger: false,
          valueRange: {
            min: -10000,
            max: 10000,
          }
        }"
        class="rounded-0 autobet-action-input grey100--text"
        solo hide-details flat dense

        @change="onChange"
      >
        <template #prepend-inner>
          <v-btn-toggle
            v-model="form.onLossAction"
            class="mr-2"
            mandatory dense tile borderless

            @change="onChange"
          >
            <v-btn
              value="reset"
              :ripple="false" small text
              class="text-caption text-none mr-1"
              @click="form.onLossValue = 0; onChange()"
            >
              Reset
            </v-btn>
            <v-btn
              value="increase"
              :ripple="false" small text
              class="text-caption text-none"
            >
              Increase by:
            </v-btn>
          </v-btn-toggle>
        </template>
        <template #append>
          <fai
            class="text-body-"
            :icon="['fad', 'percentage']"
          />
        </template>
      </v-currency-field>
    </v-col>

    <v-col cols="6">
      <h4 class="text-caption font-weight-semibold mb-1">
        Stop on profit
      </h4>
      <v-currency-field
        v-model="form.stopOnProfit"
        :options="{
          allowNegative: false,
          valueAsInteger: true,
          valueRange: {
            min: 0,
          }
        }"
        class="rounded-0 grey100--text"
        solo hide-details flat dense
        @change="onChange"
      >
        <template #prepend-inner>
          <img width="16" class="mr-1" src="@/assets/img/scrap.png">
        </template>
      </v-currency-field>
    </v-col>

    <v-col cols="6">
      <h4 class="text-caption font-weight-semibold mb-1">
        Stop on loss
      </h4>
      <v-currency-field
        v-model="form.stopOnLoss"
        :options="{
          valueAsInteger: true,
          valueRange: {
            min: 0,
          }
        }"
        class="rounded-0 grey100--text"
        solo hide-details flat dense
        @change="onChange"
      >
        <template #prepend-inner>
          <img width="16" class="mr-1" src="@/assets/img/scrap.png">
        </template>
      </v-currency-field>
    </v-col>

    <v-col cols="12" class="mt-2">
      <v-switch
        v-model="form.active"
        color="green500" class="ml-2 mt-0"
        inset hide-details dense
        label="Turn on autobet"
        @change="onChange"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: { ...this.value },
    }
  },
  watch: {
    value(val) {
      this.form = { ...val }
    },
  },
  methods: {
    onChange() {
      this.$emit('input', { ...this.form })
    },
  },
}
</script>

<style lang="scss" scoped>
.autobet-action-input {
  ::v-deep .v-input__slot {
    padding-left: 6px !important;

    .v-btn-toggle {
      pointer-events: initial !important;
    }
  }
}
</style>
